import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import moment from 'moment';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import { FormApi } from 'final-form';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Prefixes from 'src/models/Prefixes';
import Suffixes from 'src/models/Suffixes';
import { convertMartialStatusesToSelectList } from 'src/models/MaritalStatus';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IIndividualOwnerFormProps {
    handleOnSubmit: (formValues: OwnerIndividual) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

// state interface to trigger rerender on form update
interface IIndividualOwnerFormState {
    form: FormApi;
}

class IndividualOwnerForm extends React.Component<IIndividualOwnerFormProps, IIndividualOwnerFormState> {
    constructor(props: IIndividualOwnerFormProps) {
        super(props);
        this.state = { form: undefined };
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};

        if (!_.get(values, 'individualOwner.firstName')) {
            _.set(errors, 'individualOwner.firstName', 'Required');
        }
        if (!_.get(values, 'individualOwner.lastName')) {
            _.set(errors, 'individualOwner.lastName', 'Required');
        }
        return errors;
    };

    componentWillUnmount(): void {
        this.setState({ form: undefined });
    }

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerIndividual(formValues.individualOwner);
        updatedOwnerDetail.addressInformationDate = new Date(formValues.formattedDate);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();

        const ownerIndividual = this.props.ownerData.ownerDetails as OwnerIndividual;
        const formattedAddressInformationDate = ownerIndividual.addressInformationDate
            ? moment(new Date(ownerIndividual.addressInformationDate)).format('YYYY-MM-DD')
            : undefined;

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>Individual Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    style={{ padding: '3rem', paddingTop: '2rem' }}
                    initialValues={{
                        individualOwner: ownerIndividual,
                        formattedDate: formattedAddressInformationDate,
                    }}
                    validate={this.validateForm}
                    hasFieldArray={true}
                    onFormCreated={(form) => {
                        if (!this.state.form) {
                            this.setState({ form: form });
                        }
                    }}
                >
                    <div style={{ marginTop: '1rem' }}>
                        <FormSelect 
                            style={{ width: '10%' }} 
                            name="individualOwner.prefix" 
                            items={Prefixes} 
                            label="Prefix" 
                            className="lh-fifth-width" 
                        />
                        <FormTextBox
                            style={{ width: '20%', marginLeft: '.5rem' }}
                            name="individualOwner.firstName"
                            label="First Name"
                            className="lh-third-width"
                            isRequired={true}
                        />
                        <FormTextBox 
                            style={{ width: '19%', marginLeft: '.5rem' }} 
                            name="individualOwner.middleName" 
                            label="Middle Name" 
                            className="lh-third-width" 
                        />
                        <FormTextBox
                            style={{ width: '19%', marginLeft: '.5rem' }}
                            name="individualOwner.lastName"
                            label="Last Name"
                            className="lh-third-width"
                            isRequired={true}
                        />
                        <FormSelect 
                            style={{ width: '10%', marginLeft: '.5rem' }} 
                            name="individualOwner.suffix" 
                            items={Suffixes} 
                            label="Suffix" 
                            className="lh-fifth-width" 
                        />
                        <FormTextBox 
                            style={{ width: '19.5%', marginLeft: '.5rem' }} 
                            name="individualOwner.akaName" 
                            label="A/K/A" 
                            className="lh-third-width" 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}> 
                            Spouse
                        </legend>
                    </fieldset>
                    <div>
                        <FormSelect
                            items={convertMartialStatusesToSelectList()}
                            style={{ width: '20%' }}
                            name="individualOwner.maritalStatusId"
                            label="Marital Status"
                            className="lh-third-width"
                        />
                        <FormTextBox
                            style={{ width: '20%' }}
                            name="individualOwner.spouseFirstName"
                            label="Spouse First Name"
                            className="lh-third-width"
                        />
                        <FormTextBox
                            style={{ width: '19.4%', marginLeft: '.5rem' }}
                            name="individualOwner.spouseMiddleName"
                            label="Spouse Middle Name"
                            className="lh-third-width"
                        />
                        <FormTextBox 
                            style={{ width: '19.4%', marginLeft: '.5rem' }} 
                            name="individualOwner.spouseLastName" 
                            label="Spouse Last Name" 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            style={{ width: '19.4%', marginLeft: '.5rem' }} 
                            name="individualOwner.spouseAkaName" 
                            label="Spouse A/K/A" 
                            className="lh-third-width" 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Address</legend>
                    </fieldset>
                    <div>
                        <FormTextBox 
                            name="individualOwner.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-half-width" 
                        />
                        <FormTextBox 
                            name="individualOwner.address.addressLine2" 
                            label="Address Line 2" 
                            className="lh-half-width" 
                        />
                    </div>
                    <div>
                        <FormTextBox 
                            name="individualOwner.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                        />
                        <FormTextBox    
                            name="individualOwner.address.city" 
                            label="City" 
                            className="lh-third-width"
                        />
                        <FormSelect
                            name="individualOwner.address.stateId"
                            label="State"
                            items={selectStates}
                            className="lh-third-width"
                            style={{marginLeft: '.5rem'}}
                        />
                    </div>
                    <div>
                        <div style={{ display: 'flex' }}>
                            <FormTextBox
                                name="individualOwner.ssnTaxId"
                                label="SSN"
                                className="lh-half-width"
                            />
                            <FormTextBox
                                name="formattedDate"
                                label="Date of Address Information"
                                className="lh-half-width"
                                type={FormTextBoxDataType.Date}
                            />
                        </div>
                        <div style={{ display: 'flex' }}>
                            <FormTextBox
                                name="individualOwner.email"
                                label="Email"
                                className="lh-half-width"
                            />
                        </div>
                        <div>
                            <FormCheckbox 
                                name="individualOwner.isClientAcreage" 
                                label="This is the Client" 
                            />
                        </div>
                        <div style={{marginLeft: '.5rem'}} >
                            <MultiplePhoneNumber 
                                baseFieldName="individualOwner" 
                                form={this.state.form} 
                                phoneNumberTypes={this.props.phoneNumberTypes} 
                            />
                        </div>
                    </div>
                    <div className="button-row" style={{marginLeft: '.5rem'}} >
                        <Button text="Save" type="submit" intent="primary" />
                    </div>
                </Form>
            </div>
        );
    }
}

export default IndividualOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/IndividualOwnerForm.tsx